import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
// import { RouterOutlet, Router, ActivationStart } from '@angular/router';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { SavingsService } from "../shared/savings.service";
import { PrintreceiptService } from "../shared/printreceipt.service";

@Component({
  selector: 'app-savingslist',
  templateUrl: './savingslist.component.html',
  styleUrls: ['./savingslist.component.css']
})

export class SavingslistComponent implements OnInit {

  displayedColumns: string[] = ['Application No', 'Application Date', 'Customer', 'Amount', 'Scheme', 'Interest',
    'DepositDate', 'MaturityDate', 'Branch', 'New'];

  dataSource = new MatTableDataSource<any>();
 @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  constructor(private savingsService: SavingsService, private printreceiptService: PrintreceiptService,  private router: Router,
      private route: ActivatedRoute) { }

  ngOnInit() {
    this.getSavingsList();
    this.dataSource.paginator = this.paginator;
  }

  getSavingsList() {
    this.savingsService.FetchSavingsList()
      .toPromise()
      .then(data => {
        this.dataSource.data = data;
      })
      .catch(err => { console.log(err) });
  }

  public AddNewSavings() {
    this.router.navigate(['/savings']);
  }

  EditSavings(savings: any) {
    this.router.navigate(['/savings', savings.Id]);
  }

  PrintSavingsReceipt(txt:any,savings: any) {
    this.printreceiptService.GetSavingsBySavingsNo(savings);
    // this.router.navigate(['/savingsreceipt', savings.Id]);
  }

  applyFilter(filterValue: string) {

    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }

  
}
